// extracted by mini-css-extract-plugin
export var errorsContainer = "_rf-1";
export var link = "_rf-0";